<template>
  <CModal
    :title="title"
    :color="color"
    :show.sync="showModal"
    size="lg"
  >
    <CForm>
      <CRow>         
        <CCol md="6">
          <div role="group" class="form-group">
            <label> Fecha:</label>
            <v-date-picker
              class="date-picker"
              v-model="form.date"
              :isValid="checkIfValid('date')"
              locale="es-MX" size="sm"
            />
          </div>
        </CCol>                   
        <CCol md="6">
          <CSelect
              label="Persona:"
              :value.sync="form.asset_person_id"
              :isValid="checkIfValid('asset_person_id')"
              :options="personsOptions"
              invalidFeedback="Este campo es requerido."
            />                            
        </CCol>                                                             
      </CRow>
      <CRow>
        <CCol md="12">
          <CInput
            label="Motivo o razón:"
            :lazy="false"
            v-model="form.description"
            placeholder=""
            autocomplete="given-description"
            :isValid="checkIfValid('description')"
            invalidFeedback="Este campo es requerido."
          />
          <CInput
          :lazy="false"
          v-model="form.vehicle_id"
          hidden
        />
        </CCol>            
      </CRow>
  </CForm>
  <template #footer>
    <CButton @click="closeModal" color="secondary">Cancelar</CButton>
    <CButton @click="store" :color="color">Aceptar</CButton>
  </template>
  </CModal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'
import ws_per from '../../services/asset_persons'
import { DatePicker } from 'v-calendar'
import moment from 'moment'
import moment_timezone from 'moment-timezone'
import store from '../../store'

export default {
  name: 'PropertyAssignModal',
  components: {
    'v-date-picker': DatePicker
  },
  mixins: [validationMixin],
  data () {
    return {
      showModal: false,
      title: "Asignar Propiedad",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      personsOptions: [],
    }
  },
  methods: {
    getEmptyForm () {
      return {
        id: null,
        description: "",
        date: moment().toDate(),
        property_id: 0,
        asset_person_id: '',
      }
    },
    async openModal (property) {
      this.loading();
      
      try {
        await this.loadPersons()

        this.isEdit = false
        this.title = 'Asignar Propiedad'
        this.color = 'warning'

        this.form = this.getEmptyForm()
        this.form.property_id = property.id

        this.showModal = true
      } finally {
        this.loaded()
      }
    },

    async storeModal (item) {
      console.log("storeModal")
      console.log(item)
      this.loading()
      try {
        await this.loadPersons()
        this.showModal = true;
        this.color = "info";
        this.title = 'Asignar Propiedad';
        this.isEdit = false;
        this.submitted = false;

        this.form = {
          id: 0,
          date: moment().toDate(),
          description: '',
          property_id: item.id,
          asset_person_id: item.asset_person_id,
        };

        this.showModal = true;
      } finally {
        this.loaded()
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Reasignar Vehículo';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          date: moment().toDate(),
          description: '',
          property_id: item.id,
          asset_person_id: item.asset_person_id,
      };
    },
    async loadPersons () {
      const responsePer = await ws_per.get()
      if (responsePer.type === 'success') {
        this.personsOptions = [{ value: 0, label: 'Selecciona un responsable' }].concat(
          responsePer.data.map(p => ({ value: p.id, label: p.name }))
        )
      }
    },
    store () {
      this.submitted = true;

      if(this.form.id > 0){
        this.$emit("update", this.form );
      }
      else{
        this.$emit("store", this.form );
      }

      this.closeModal();
    },
    closeModal () {
      this.showModal = false
      this.form = this.getEmptyForm()
    },
    checkIfValid (field) {

    },
    loading () {
      store.commit('loading')
    },
    loaded () {
      store.commit('loaded')
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      description: {   
        required     
      },
      date: {        
        required,
      },
      property_id: {
        required,
        minValue: minValue(1)
      },
      asset_person_id: {
        required,
        minValue: minValue(1)
      }
    }
  },
}
</script>
